import { FC, useEffect, useState } from 'react';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';
import { taskSpotDetail, taskSpotDetailDemo } from '@/common/api/passengerflowcount';
import styles from './index.module.less';
import Top from 'src/views/expandstore/pages/passengerflowcount/components/SpotDetailDrawer/Top';
import Main from 'src/views/expandstore/pages/passengerflowcount/components/SpotDetailDrawer/Main';

/**
 * 客流计数-点位详情
 * @description // src/views/expandstore/pages/passengerflowcount/components/SpotDetailDrawer/index.tsx
 * @demo
 */
const Component:FC<{
  id,
  /** 分享时调用接口需要的数据，如果有值代表“分享时” */
  shareData?,
  /** 是否展示演示模式 */
  isDemonstrate?: boolean;
  /** 是否展示机会点操作 */
  ableToChangepoint?: boolean;
  className?: string,
}> = ({ id, shareData, isDemonstrate, ableToChangepoint = true, className }) => {

  shareData;

  /* state */
  const [spotDetail, setSpotDetail] = useState<any>({}); // 点位详情

  /* hooks */
  useEffect(() => {
    if (id) { // 20240829换了接口，换成点位列表接口
      methods.getTaskSpotDetail();
    }
  }, [id]);

  /* methods */
  const methods = useMethods({
    getTaskSpotDetail() {
      const api = isDemonstrate ? taskSpotDetailDemo : taskSpotDetail;
      // 0829换了接口，换成点位列表接口
      api(id).then((res) => {
        setSpotDetail({ ...res.data || {} });
      });
    },
  });

  return (<div className={cs(styles.container, className)}>
    <Top detail={spotDetail} ableToChangepoint={ableToChangepoint} disabled={!!shareData} />
    <Main spotDetail={spotDetail} isDemonstrate={isDemonstrate} disabled={!!shareData}/>
  </div>);
};

export default Component;
